import { Product } from '@gid/models';

export const PRODUCT_DEFINITIONS_FETCH = 'PRODUCT_DEFINITIONS_FETCH',
  PRODUCTS_SELECTED_ADD = 'PRODUCTS_SELECTED_ADD',
  PRODUCTS_SELECTED_ITEM_DELETE = 'PRODUCTS_SELECTED_ITEM_DELETE',
  PRODUCTS_SELECTED_JOB_ITEMS_ADD = 'PRODUCTS_SELECTED_JOB_ITEMS_ADD',
  PRODUCTS_SELECTED_SET = 'PRODUCTS_SELECTED_SET',
  PRODUCTS_SELECTED_UNSET = 'PRODUCTS_SELECTED_UNSET',
  PRODUCT_OPPORTUNITIES_FETCH = 'PRODUCT_OPPORTUNITIES_FETCH',
  PRODUCT_PRESELECT_AUTOMATION = 'PRODUCT_PRESELECT_AUTOMATION',
  PRODUCT_SUPPLIERS_FETCH = 'PRODUCT_SUPPLIERS_FETCH';

export interface ProductsState {
  definitions: {
    [productId: string]: Product;
  };
  definitionsByOpportunity: {
    [opportunityId: string]: Product[];
  };
  selected: {
    [jobId: string]: Product[];
  };
  suppliers: any;
}
